/**
 * 美股JS
 */
import gotowap from "../src/modules/gotowap";
import gonggao from "../src/modules/gonggao";
import new_news from "../src/modules/new_news/web";
import txt from "../src/modules/txt";

declare var stockEnity:any

gotowap(stockEnity.stockCode, stockEnity.MktNum);

//公告
var gg = new gonggao({
    boxid: "#stock-gonggao-wap",
    size: 5,
    market: stockEnity.MktNum,
    stockcode: stockEnity.stockCode,
    showtime:true,
    titlelength:42
});

//新闻
new_news.getNews(stockEnity.UnifiedID).then(function(list){
  if(list.length > 0){
    $('#stocknews ul').html(list.map(function(v){
      return `<li class="clearfix"><a target="_blank" title="${v.Art_Title}" href="${v.Art_Url}">${v.Art_Title}</a><i class="fr">${v.Art_ShowTime.substring(5,10)}</i></li>`
    }).join(''))    
  }
  else{
    $('#stocknews ul').html(`<div style="line-height:140px; text-align:center;">暂无该股资讯</div>`)
  }
})

/**
 * 自选股相关功能
 */
import quote_zxg from "../src/modules/newzxg/quote_zxg_b";
quote_zxg(stockEnity.UnifiedID, {
  leftcount: 9
})

require('../src/modules/old_us/us')